/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-06-09",
    versionChannel: "nightly",
    buildDate: "2023-06-09T00:20:22.301Z",
    commitHash: "650f872b19f0e520b4b1aac629a44c886538a860",
};
